import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import {
  InsuredItem,
  SingleFieldStepProps,
  YesNoAnswer,
  YES_NO_OPTIONS,
} from 'scenes/common/types';
import { SegmentedControlQuestion } from 'scenes/common/components/Questions';
import { SlideIn, SubmitButton } from 'components';

export const RENOVATION_CURRENT = 'propertyRenovationCurrent';

export const QUESTION_FUTURE =
  'Is any construction, renovation or demolition planned for the next 6 months?';
export const RENOVATION_FUTURE = 'propertyRenovationFuture';

const PropertyRenovationStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext'> & {
    propertyRenovationCurrentDefault: YesNoAnswer;
    propertyRenovationFutureDefault: YesNoAnswer;
    insuredItem: InsuredItem;
  }
> = ({
  onNext,
  propertyRenovationCurrentDefault,
  propertyRenovationFutureDefault,
  insuredItem,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    control,
    errors,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const watchedQuestionCurrent = watch(
    RENOVATION_CURRENT,
    propertyRenovationCurrentDefault
  );

  const questionCurrent = `Is the ${insuredItem} currently undergoing any construction, renovation or demolition?`;

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SegmentedControlQuestion
        question={questionCurrent}
        stateKey={RENOVATION_CURRENT}
        defaultValue={propertyRenovationCurrentDefault}
        options={YES_NO_OPTIONS}
        errors={errors}
        control={control}
      />
      {watchedQuestionCurrent === YesNoAnswer.No && (
        <SlideIn>
          <SegmentedControlQuestion
            question={QUESTION_FUTURE}
            stateKey={RENOVATION_FUTURE}
            defaultValue={propertyRenovationFutureDefault}
            options={YES_NO_OPTIONS}
            errors={errors}
            control={control}
          />
        </SlideIn>
      )}
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default PropertyRenovationStep;
